import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'infrastructure/js/components/controls/TextField/textField';
import Validation from 'infrastructure/js/components/controls/controlsValidations.js';
import GenerateButton from 'infrastructure/js/components/controls/GenerateButton/generateButton';
import Normalize from 'infrastructure/js/components/controls/controlsNormalizations';

import'./subRollListItem.scss';

export default class SubRollListItem extends React.PureComponent {

  onClickCallback = () => {
    this.props.onGenerateClickCallback?.(this.props.index);
  };

  onChangeCallback = (value) => {
    this.props.onQuantityChangedCallback?.(value);
  };

  maxLength50 = Validation.maxLength(50);

  render() {
    let {name} = this.props;

    return (
      <div className="subroll-list-item">
        <GenerateButton id={ name + '.[subRoll]'}
                        name={ name + '.[subRoll]'}
                        className="rollId"
                        placeholder={this.props.labels.get('subrollslist.item.placeholder')}
                        validate={[Validation.required, this.maxLength50]}
                        onClick={this.onClickCallback}
                        buttonText={this.props.labels.get('subrollslist.item.button.generate')}
        />
        <TextField id={ name + '.[quantity]'}
                   name={ name + '.[quantity]'}
                   className="short-textfield"
                   normalize={Normalize.normalizeFloat(0, parseFloat(this.props.quantityLeft))}
                   validate={Validation.required}
                   onChangeCallback={this.onChangeCallback}
        />
      </div>);
  }
}

SubRollListItem.propTypes = {
  item: PropTypes.object,
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};




